export default function SET_START_TEST_TUTOMAT(state, tutomatData) {
    state.tutomat = tutomatData;
}